import $ from 'jquery'

const DEPENDENCY_HIDDEN_CLASS = 'is-dependency-hidden'
const DEPENDENCY_EVENT_NAMESPACE = '.eloquaDependence'
const REQUIRED_MARKER = '*'

export const DEPENDENCY_HIDDEN_INPUT_SELECTOR = `.${DEPENDENCY_HIDDEN_CLASS} *`

export function getDependence (moduleId, rulesObjectBlueprint) {
  updateCheckboxes()
  // dependence function
  if (window.eloquaForm['extraSettings'] && window.eloquaForm['extraSettings'][moduleId]) {
    let dependenceDefinition = window.eloquaForm['extraSettings'][moduleId]
    const moduleRules = rulesObjectBlueprint[moduleId]
    const nativeRequiredFieldNames = new Set(Object.keys(moduleRules).filter(fieldName => moduleRules[fieldName].required === true))

    $.each(dependenceDefinition, function (key, definiton) {
      let dependenceElement = $('[name="' + key + '"]')
      $.each(definiton, function (dependenceValue, settings) {
        const isNoValueOfSingleElement = dependenceElement.length === 1 && dependenceValue === 'noValue'

        $.each(settings, function (i, settingDefinition) {
          if (!isCollapseTarget(settingDefinition, nativeRequiredFieldNames)) return
          let field = $('[name="' + settingDefinition.field + '"]')
          let instructionText = field.closest('.formRow--col').prev()

          if ((isNoValueOfSingleElement ? instructionText.parent() : instructionText).hasClass('is-instruction-text')) {
            instructionText.addClass('collapse')
          }
          field.closest('.formRow').parent().addClass('collapse')
        })
      })

      dependenceElement.on('change', function () {
        syncDependencyVisibility(dependenceDefinition, nativeRequiredFieldNames)
      })
    })
    addDependencyRequiredRules(moduleRules, dependenceDefinition, nativeRequiredFieldNames)
    syncDependencyVisibility(dependenceDefinition, nativeRequiredFieldNames)
  }
  return rulesObjectBlueprint
}

export function getDependencyRequiredFieldNames (moduleId) {
  const extraSettings = window.eloquaForm['extraSettings']
  return extraSettings && extraSettings[moduleId] ? collectRequiredFieldNames(extraSettings[moduleId]) : []
}

function collectRequiredFieldNames (dependenceDefinition) {
  const requiredFieldNames = new Set()
  $.each(dependenceDefinition, function (triggerName, definition) {
    $.each(definition, function (dependenceValue, settings) {
      $.each(settings, function (i, settingDefinition) {
        if (settingDefinition.required) {
          requiredFieldNames.add(settingDefinition.field)
        }
      })
    })
  })
  return Array.from(requiredFieldNames)
}

function addDependencyRequiredRules (moduleRules, dependenceDefinition, nativeRequiredFieldNames) {
  collectRequiredFieldNames(dependenceDefinition).forEach(function (fieldName) {
    if (nativeRequiredFieldNames.has(fieldName)) return
    const isRequired = function () {
      return resolveTargetRequiredness(dependenceDefinition, nativeRequiredFieldNames).get(fieldName)
    }
    const fieldRules = moduleRules[fieldName] = moduleRules[fieldName] || {}
    fieldRules.required = { depends: isRequired }
    if (isChoiceField($('[name="' + fieldName + '"]'))) {
      fieldRules.valueNotEquals = { param: 'default', depends: isRequired }
    }
  })
}

function isChoiceField (field) {
  return field.length > 0 && (field[0].type === 'checkbox' || field[0].type === 'select-one')
}

function isCollapseTarget (settingDefinition, nativeRequiredFieldNames) {
  return settingDefinition.collapse && !nativeRequiredFieldNames.has(settingDefinition.field)
}

function syncDependencyVisibility (dependenceDefinition, nativeRequiredFieldNames) {
  const targetVisibility = resolveTargetVisibility(dependenceDefinition, nativeRequiredFieldNames)
  const rowVisibility = new Map()

  targetVisibility.forEach(function (isShown, targetName) {
    const field = $('[name="' + targetName + '"]')
    field.closest('.formRow').parent()
      .add(field.closest('.formRow--col').prev('.is-instruction-text'))
      .each(function () {
        rowVisibility.set(this, rowVisibility.get(this) || isShown)
      })
  })

  rowVisibility.forEach(function (isShown, row) {
    const $row = $(row)
    $row.toggleClass(DEPENDENCY_HIDDEN_CLASS, !isShown).collapse(isShown ? 'show' : 'hide')
    if ($row.hasClass('collapsing')) {
      $row.off(DEPENDENCY_EVENT_NAMESPACE).on(
        'shown.bs.collapse' + DEPENDENCY_EVENT_NAMESPACE + ' hidden.bs.collapse' + DEPENDENCY_EVENT_NAMESPACE,
        function () {
          $(this).off(DEPENDENCY_EVENT_NAMESPACE)
          syncDependencyVisibility(dependenceDefinition, nativeRequiredFieldNames)
        })
    }
  })

  resolveTargetRequiredness(dependenceDefinition, nativeRequiredFieldNames, targetVisibility).forEach(updateRequiredMarker)
}

function updateRequiredMarker (isRequired, fieldName) {
  const placeholderText = $('[name="' + fieldName + '"]').first().siblings('.placeholder').find('.placeholder-text')
  const text = placeholderText.text()

  if (isRequired && !text.endsWith(REQUIRED_MARKER)) {
    placeholderText.text(text + REQUIRED_MARKER)
  } else if (!isRequired && text.endsWith(REQUIRED_MARKER)) {
    placeholderText.text(text.slice(0, -REQUIRED_MARKER.length))
  }
}

function resolveTargetRequiredness (dependenceDefinition, nativeRequiredFieldNames,
  targetVisibility = resolveTargetVisibility(dependenceDefinition, nativeRequiredFieldNames)) {
  const isShown = fieldName => !targetVisibility.has(fieldName) || targetVisibility.get(fieldName)
  const requiredness = new Map()

  $.each(dependenceDefinition, function (triggerName, definition) {
    $.each(definition, function (dependenceValue, settings) {
      $.each(settings, function (i, settingDefinition) {
        const fieldName = settingDefinition.field
        if (!settingDefinition.required || nativeRequiredFieldNames.has(fieldName) || requiredness.get(fieldName)) return
        requiredness.set(fieldName, isShown(fieldName) && isShown(triggerName) && isDependenceMatched(triggerName, dependenceValue))
      })
    })
  })

  return requiredness
}

function resolveTargetVisibility (dependenceDefinition, nativeRequiredFieldNames) {
  const targetRules = new Map()

  $.each(dependenceDefinition, function (triggerName, definition) {
    $.each(definition, function (dependenceValue, settings) {
      const isMatched = isDependenceMatched(triggerName, dependenceValue)
      $.each(settings, function (i, settingDefinition) {
        if (!isCollapseTarget(settingDefinition, nativeRequiredFieldNames)) return
        if (!targetRules.has(settingDefinition.field)) {
          targetRules.set(settingDefinition.field, [])
        }
        targetRules.get(settingDefinition.field).push({ triggerName, isMatched })
      })
    })
  })

  const targetVisibility = new Map(Array.from(targetRules.keys(), targetName => [targetName, false]))

  let hasNewlyShownTarget = true
  while (hasNewlyShownTarget) {
    hasNewlyShownTarget = false
    targetRules.forEach(function (rules, targetName) {
      if (targetVisibility.get(targetName)) return
      if (rules.some(rule => rule.isMatched && (!targetRules.has(rule.triggerName) || targetVisibility.get(rule.triggerName)))) {
        targetVisibility.set(targetName, true)
        hasNewlyShownTarget = true
      }
    })
  }

  return targetVisibility
}

function isDependenceMatched (triggerName, dependenceValue) {
  const triggerElements = $('[name="' + triggerName + '"]')

  if (dependenceValue === 'noValue') {
    return triggerElements.toArray().some(hasAnyValue)
  }
  if (triggerName.indexOf('multi_checkboxes[]') > -1) {
    return triggerElements.length > 0 && checkMultiCheckboxDependence(triggerElements, dependenceValue)
  }
  return triggerElements.toArray().some(element => element.value === dependenceValue &&
    (element.checked || (element.type !== 'radio' && element.type !== 'checkbox')))
}

function hasAnyValue (triggerElement) {
  if (triggerElement.type === 'checkbox') {
    return !$(triggerElement).hasClass('is-multiple') && triggerElement.checked
  }
  if (triggerElement.type === 'select-one') {
    return triggerElement.value !== 'default'
  }
  if (triggerElement.type === 'text' || triggerElement.type === 'textarea') {
    return triggerElement.value !== ''
  }
  return false
}

function checkMultiCheckboxDependence (dependenceElement, dependenceValue) {
  let parent = dependenceElement.closest('.is-multiple-wrapper[data-active-checkbox]')
  let dataValue = parent.attr('data-active-checkbox')
  let arrayCheckboxes = dataValue.split(';')
  let multiDependence = dependenceValue.split(';')
  let show = false

  for (let i = 0; i < multiDependence.length; i++) {
    if (multiDependence[i].indexOf('&') != -1) {
      let dependence = multiDependence[i].split('&')

      if (dependence.length == arrayCheckboxes.length) {
        if (dependence.every(item => arrayCheckboxes.indexOf(item) != -1)) {
          show = true
        }
      }
    } else {
      if (multiDependence[i] == arrayCheckboxes[0] && arrayCheckboxes.length == 1) {
        show = true
      }
    }
  }

  return show
}

function updateCheckboxes () {
  let checkboxes = document.querySelectorAll('.eloqua-form input[type="checkbox"]')
  for (let i = 0; i < checkboxes.length; i++) {
    let checkBox = checkboxes[i]
    if (!checkBox.disabled) {
      checkBox.checked = false
    }
  }

  let checkboxContainer = $('.is-multiple-wrapper[data-active-checkbox]')

  if (checkboxContainer.length > 0) {
    checkboxContainer.each(function () {
      let checkboxWrapper = $(this)
      let checkbox = checkboxWrapper.find('input[type=\'checkbox\']')

      checkbox.each(function () {
        $(this).on('click', function () {
          let checkboxVal = $(this).val(),
            checkboxData = checkboxWrapper.attr('data-active-checkbox')
          if ($(this).is(':checked')) {
            if (checkboxData) {
              checkboxWrapper.attr('data-active-checkbox', checkboxData + ';' + checkboxVal)
            } else {
              checkboxWrapper.attr('data-active-checkbox', checkboxVal)
            }
          } else {
            if (checkboxData.endsWith(checkboxVal)) {
              if (checkboxData.indexOf(';') != -1) {
                let updatedCheckboxData = checkboxData.split(';' + checkboxVal)
                checkboxWrapper.attr('data-active-checkbox', updatedCheckboxData[0])
              } else {
                let updatedCheckboxData = checkboxData.split(checkboxVal)
                checkboxWrapper.attr('data-active-checkbox', updatedCheckboxData[0])
              }
            } else {
              let updatedCheckboxData = checkboxData.split(checkboxVal + ';')
              checkboxWrapper.attr('data-active-checkbox', updatedCheckboxData[0] + updatedCheckboxData[1])
            }
          }
        })
      })
    })
  }
}
